import { BILLING_FUNNEL_HEADERS, BILLING_FUNNEL_TOTAL } from 'utils/constants/admin';

import useTrls from 'hooks/translation/useTrls';

import Table from 'components/Table';

import TableBody from 'components/Table/TableBody';
import TableCell from 'components/Table/TableCell';
import TableHead from 'components/Table/TableHead';
import TableHeadCell from 'components/Table/TableHeadCell';
import TableRow from 'components/Table/TableRow';

import { useSelector } from 'store/utils';

import 'components/Admin/Reports/BillingFunnelReport/BillingFunnelTable/BillingFunnelTable.less';

const BillingFunnelTable = () => {
    const { billingFunnelData, billingFunnelTotal } = useSelector((state) => state.billingFunnel);
    const trl = useTrls();

    const { statisticAmount, fixedStatisticAmount, fixedStatisticRealAmount, fixedStatisticBonusAmount, actAmount } =
        billingFunnelTotal;

    return (
        <Table fullWidth withStripes bordered>
            <TableHead>
                <TableRow>
                    {BILLING_FUNNEL_HEADERS.map((header) => (
                        <TableHeadCell key={header}>{trl(`admin.billingFunnelReport.header.${header}`)}</TableHeadCell>
                    ))}
                </TableRow>
                <TableRow>
                    <TableHeadCell>{trl(`admin.billingFunnelReport.header.${BILLING_FUNNEL_TOTAL}`)}</TableHeadCell>
                    <TableHeadCell>{statisticAmount}</TableHeadCell>
                    <TableHeadCell>{fixedStatisticAmount}</TableHeadCell>
                    <TableHeadCell>{fixedStatisticRealAmount}</TableHeadCell>
                    <TableHeadCell>{fixedStatisticBonusAmount}</TableHeadCell>
                    <TableHeadCell>{actAmount}</TableHeadCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {billingFunnelData.map(
                    ({
                        accountId,
                        statisticAmount,
                        statisticAndFixedStatisticDiff,
                        fixedStatisticAmount,
                        fixedStatisticRealAmount,
                        realFixedStatisticAndActDiff,
                        fixedStatisticBonusAmount,
                        actAmount,
                    }) => (
                        <TableRow key={accountId}>
                            <TableCell>{accountId}</TableCell>
                            <TableCell>
                                {statisticAmount}
                                {statisticAndFixedStatisticDiff !== 0 && statisticAndFixedStatisticDiff && (
                                    <span className="billing-funnel-report-diff">
                                        {` (${statisticAndFixedStatisticDiff})`}
                                    </span>
                                )}
                            </TableCell>
                            <TableCell>{fixedStatisticAmount}</TableCell>
                            <TableCell>
                                {fixedStatisticRealAmount}
                                {realFixedStatisticAndActDiff !== 0 && realFixedStatisticAndActDiff && (
                                    <span className="billing-funnel-report-diff">
                                        {` (${realFixedStatisticAndActDiff})`}
                                    </span>
                                )}
                            </TableCell>
                            <TableCell>{fixedStatisticBonusAmount}</TableCell>
                            <TableCell>{actAmount}</TableCell>
                        </TableRow>
                    )
                )}
            </TableBody>
        </Table>
    );
};

export default BillingFunnelTable;
